<template>
 <div v-if="dadosBeneficiarioResponse" class="q-pa-md">
     <q-card  class="dados-beneficiario">
        <DadosBeneficiarioComponent :dados-beneficiario = dadosBeneficiarioResponse />
     </q-card>
     <q-card v-if="enableTipoProposta" class="dados-tipo-proposta">
        <TipoPropostaComponent :dados-beneficiario = dadosBeneficiarioResponse :dados-proposta = dadosBeneficiarioResponse  @propostaBancoConfirmacao="propostaBancoConfirmacao($event)" />
     </q-card>
     <div>
        <ConfirmacaoNumeroComponent :dados-beneficiario = dadosBeneficiarioResponse
        :propostaConfirmarBanco = propostaConfirmarBanco
        :modalConfirmacao = modalConfirmacao
        @closeModalConfirmacao="eventModalConfirmacao($event)"/>
     </div>
      <div>
        <InformacaoProposta
        :modalInformativo = modalInformativo
        @closeModalInformativo="eventModalInformativo($event)"/>
     </div>
 </div>
</template>

<script>
import DadosBeneficiarioComponent from '@/views/proposta/DadosBeneficiario'
import TipoPropostaComponent from '@/views/proposta/TipoProposta'
import ConfirmacaoNumeroComponent from '@/views/proposta/ConfirmacaoNumero'
import InformacaoProposta from '@/views/proposta/InformacaoProposta'
import BeneficiarioService from '@/services/beneficiario'

export default {
  data () {
    return {
      dadosBeneficiarioResponse: null,
      propostaConfirmarBanco: null,
      modalConfirmacao: null,
      modalInformativo: null,
      enableTipoProposta: false,
      dadosBeneficiarioProposta: null
    }
  },
  components: {
    DadosBeneficiarioComponent,
    TipoPropostaComponent,
    ConfirmacaoNumeroComponent,
    InformacaoProposta
  },
  mounted () {
    this.init()
    if (this.dadosBeneficiarioResponse) {
      this.showNotif()
    }
  },
  methods: {
    init () {
      if ((localStorage.getItem('Token_CAPAF') === null && localStorage.getItem('Refresh_Token_CAPAF') === null) || (localStorage.getItem('Token_CAPAF') === undefined && localStorage.getItem('Refresh_Token_CAPAF') === undefined)) {
        window.location.href = '/'
      }
      BeneficiarioService.lista().then(resposta => {
        if (resposta.data.status === 'TOKEN_INVALIDO') {
          return this.$b.nError(resposta.data.message)
        }
        if (resposta.data.status === 'ERROR') {
          return this.$b.nError(resposta.data.message)
        }
        this.dadosBeneficiarioResponse = resposta.data.data
        this.dadosConfirmar()
      })
    },
    propostaBancoConfirmacao (value) {
      this.propostaConfirmarBanco = value
      this.eventModalConfirmacao(true)
      return this.propostaConfirmarBanco
    },
    eventModalConfirmacao (value) {
      this.modalConfirmacao = value
    },
    eventModalInformativo (value) {
      this.modalInformativo = value
    },
    dadosConfirmar () {
      this.modalInformativo = true
      this.enableTipoProposta = true
      this.dadosBeneficiarioProposta = true
    },
    showNotif (position) {
      this.$q.notify({
        message: 'A simulação não representa compromisso, que só será formalizado em juízo',
        color: 'orange',
        position: 'top-right',
        actions: [{ icon: 'close', color: 'white' }],
        timeout: 1000000
      })
    }
  }
}

</script>
